import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-details-box',
    templateUrl: './details-box.component.html',
    styleUrls: ['./details-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DetailsBoxComponent {
  @Input() detailsName: string;
  @Input() forceSingleColumnTooltip = false;
  @Input() header = null;

  isString(value: unknown) {
    return typeof value === 'string';
  }

  isObject(value: unknown) {
    return typeof value === 'object';
  }

  keys(value: object) {
    return Object.keys(value);
  }
}
